// extracted by mini-css-extract-plugin
export var component = "PostsModuleHeader-module--component--7SNDl";
export var link = "PostsModuleHeader-module--link--Lbr9p";
export var linkIcon = "PostsModuleHeader-module--linkIcon--wUfts";
export var title = "PostsModuleHeader-module--title--uK1et";